import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { useNavigate } from "react-router-dom";
import "../../Config/search.css";
import "../../Config/loader.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Config/loading.css";
import AddProdcut from "./AddProduct";
import ViewProduct from "./ViewProduct";
import EditProduct from "./EditProduct";
import Swal from "sweetalert2";
import "../../Config/swal.css";
import { Footer } from "../footer/footer";

export default function Products() {
  const navigate = useNavigate();

  const [productsData, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [productViewOBJ, setProductViewObj] = useState([]);
  const [productEditOBJ, setProductEditObj] = useState([]);
  const [statusLoading, setStatusLoading] = useState(null);

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_CRM_URL}products/GetProducts`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (data.Status) {
        setProducts(data.Data);
      } else {
        console.error("Fetched data is not an array:", data);
        setProducts([]); // Set an empty array to avoid errors
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const showProductViewModal = (obj) => {
    setProductViewObj(obj);
  };

  const showProductEditModal = (obj) => {
    setProductEditObj(obj);
  };

  const handleStatusChange = async (checked, item) => {
    const newStatus = checked ? 1 : 0;

    setStatusLoading(item.id);

    try {
      const response = await fetch(`${API_BASE_CRM_URL}UpdateProductStatus`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.id,
          active: newStatus,
        }),
      });

      const result = await response.json();
      console.log("Status update result:", result);

      if (result.status) {
        Swal.fire({
          icon: "success",
          title: `Product ${
            newStatus === 1 ? "activated" : "deactivated"
          } successfully`,
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          fetchData();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to update status",
          text: result.message || "Please try again later",
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      });
    } finally {
      setStatusLoading(null);
    }
  };

  const itemsPerPage = 12;

  const filteredItems = useMemo(() => {
    const results = productsData?.filter(
      (item) =>
        item.description.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        (item.long_description &&
          item.long_description
            .toLowerCase()
            .includes(searchTerm?.toLowerCase())),
    );

    setCurrentPage(1);

    return results;
  }, [productsData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems?.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleExcelDownload = () => {
    if (productsData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    const title = [["Products Data"]];

    const headers = [
      ["Sl. No", "Size", "Name", "Tax", "Inches", "mm", "Weight"],
    ];

    const data = productsData.map((item, index) => [
      index + 1,
      item.size,
      item.name,
      item.tax,
      item.inches,
      item.mm,
      item.weight,
    ]);

    const wsData = [...title, [], ...headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers[0].length - 1 },
      },
    ];

    ws["!cols"] = [
      { wch: 8 }, // Sl. No
      { wch: 15 }, // Size
      { wch: 20 }, // Name
      { wch: 10 }, // Tax
      { wch: 12 }, // Inches
      { wch: 10 }, // mm
      { wch: 12 }, // Weight
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Products Data");

    XLSX.writeFile(wb, "productsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    doc.setProperties({
      title: "Products Data",
    });

    const title = "Products Data";
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(title, doc.internal.pageSize.getWidth() / 2, 15, {
      align: "center",
    });

    const startY = 25;

    const headers = ["Sl. No", "Size", "Name", "Tax", "Inches", "mm", "Weight"];

    const tableData = productsData.map((item, index) => [
      index + 1, // Sl. No
      item.size,
      item.name,
      item.tax,
      item.inches,
      item.mm,
      item.weight,
    ]);

    doc.autoTable({
      head: [headers],
      body: tableData,
      startY,
      styles: {
        fontSize: 10,
        halign: "center",
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        halign: "center",
      },
    });

    doc.save("productsData.pdf");
  };

  const [expandedCard, setExpandedCard] = useState(null);

  const toggleDescription = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between py-2 mb-3">
          <div className="page-title">
            <h4>Products</h4>
            <h6>Manage your Products</h6>
          </div>

          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm"
                >
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-12 mb-3">
          <div className="input-group">
            <input
              type="text"
              name="search"
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="input-group-text bg-primary">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-2">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : (
          currentItems &&
          currentItems.map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div className="card mb-2 rounded-4 ">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "50%",
                          backgroundColor: "#E3F2FD",
                          color: "#1B2850",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          marginRight: "8px",
                          textTransform: "uppercase",
                          overflow: "hidden",
                          flexShrink: 0,
                        }}
                      >
                        {item?.external_link ? (
                          <img
                            src={item.external_link}
                            alt={item?.image_name || "Device"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                            onError={(e) => {
                              e.currentTarget.style.display = "none";
                            }}
                          />
                        ) : item?.description?.trim() ? (
                          item.description.trim().substring(0, 2)
                        ) : (
                          "NA"
                        )}
                      </div>
                      <div>
                        <h5
                          className="mb-2 fw-bold"
                          style={{
                            color: "#1B2850",
                            fontSize: "15px",
                            lineHeight: "1.4",
                            overflowWrap: "anywhere",
                          }}
                          title={item.description}
                        >
                          {expandedCard === item.id
                            ? item.description || "N/A"
                            : item.description?.length > 25
                              ? `${item.description.slice(0, 25)}...`
                              : item.description || "N/A"}
                        </h5>

                        <div className="row g-1 align-items-start">
                          {/* Price */}
                          <div className="col-5">
                            <div className="gap-1">
                              <i
                                className="fa-solid fa-indian-rupee-sign"
                                style={{
                                  color: "#1B2850",
                                  width: "14px",
                                }}
                              ></i>
                              <span className="text-break">
                                {item.price || "N/A"}
                              </span>
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="d-flex align-items-center gap-1">
                              <i
                                className="fa-solid fa-layer-group"
                                style={{
                                  color: "#1B2850",
                                  width: "16px",
                                  flexShrink: 0,
                                }}
                              ></i>
                              <span className="text-break">
                                {item.group_name || "N/A"}
                              </span>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="d-flex align-items-center gap-1">
                              <i
                                className="fa-solid fa-layer-group"
                                style={{
                                  color: "#1B2850",
                                  width: "16px",
                                  flexShrink: 0,
                                }}
                              ></i>
                              <span className="text-break">
                                {item.unit || "N/A"}
                              </span>
                            </div>
                          </div>

                          {/* Tax */}
                          <div className="col-6">
                            <div className="">
                              <i
                                className="fa-solid fa-file-invoice-dollar"
                                style={{
                                  color: "#1B2850",
                                  width: "16px",
                                }}
                              ></i>
                              <span className="">{item.tax1Name || "N/A"}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="">
                              <i
                                className="fa-solid fa-file-invoice-dollar"
                                style={{
                                  color: "#1B2850",
                                  width: "16px",
                                }}
                              ></i>
                              <span className="">
                                {item.tax1Name1 || "N/A"}
                              </span>
                            </div>
                          </div>

                          {/* Group Name */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Details */}
                  <div className="card-details">
                    <div className="row g-2">
                      <style>
                        {`
                            .description-content {
                              max-height: 24px; /* collapsed height */
                              overflow: hidden;
                              transition: max-height 0.4s ease-in-out;
                              line-height: 24px;
                            }
                            
                            .description-content.expanded {
                              max-height: 300px; /* adjust as needed */
                            }`}
                      </style>
                      <div className="col-12">
                        <div className="d-flex align-items-start">
                          <i
                            className="fa-solid fa-file-lines me-2 mt-1"
                            style={{ color: "#1B2850" }}
                          ></i>

                          <div>
                            <span>
                              {expandedCard === item.id
                                ? item.long_description
                                : item.long_description?.length > 50
                                  ? `${item.long_description.slice(0, 50)}...`
                                  : item.long_description || "N/A"}
                            </span>

                            {item.long_description?.length > 57 && (
                              <i
                                className={`fa-solid ms-1 ${
                                  expandedCard === item.id
                                    ? "fa-chevron-up"
                                    : "fa-chevron-down"
                                }`}
                                style={{
                                  color: "#1B2850",
                                  cursor: "pointer",
                                  transition: "transform 0.3s ease",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                }}
                                onClick={() =>
                                  setExpandedCard(
                                    expandedCard === item.id ? null : item.id,
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        <div className="col-12">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems?.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
      <Footer></Footer>
      <AddProdcut />
      <ViewProduct productObj={productViewOBJ} />
      <EditProduct productObj={productEditOBJ} />
    </Base>
  );
}
